import { ColDef, ITooltipParams } from 'ag-grid-community';
import { TransactionTypes } from '../../models/transactions-enum';

export const fieldIdCol: ColDef = {
  field: 'id' ,
  headerName: 'FL ID',
  width: 100,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldCbreFeeCol: ColDef = {
  field: 'cbre_fee',
  headerName: 'CBRE FEE (Total)',
  minWidth: 180,
  type: 'currency',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldInvoiceValueTotalCol: ColDef = {
  field: 'invoice_value_total',
  headerName: 'Invoice Value (Total)',
  minWidth: 180,
  type: 'currency',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldInvoiceValueSplitCol: ColDef = {
  field: 'invoice_value_split',
  headerName: 'Invoice Value (FUMO)',
  minWidth: 180,
  type: 'currency',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldCbreFeeFumoBalCol: ColDef = {
  field: 'actual_fee',
  headerName: 'CBRE FEE (FUMO Balance)',
  minWidth: 180,
  type: 'currency',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldCbreRevenueTotalCol: ColDef = {
  field: 'cbre_revenue',
  headerName: 'CBRE REVENUE (Total)',
  minWidth: 180,
  type: 'currency',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldCbreRevenueFumoBalCol: ColDef = {
  field: 'flat_amount',
  headerName: 'CBRE REVENUE (FUMO Balance)',
  minWidth: 180,
  type: 'currency',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldRepresentedPartyCol: ColDef = {
  field: 'represented_party',
  headerName: 'NAME',
  minWidth: 250,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};
export const fieldReppedCustomer: ColDef = {
  field: 'repped_customer',
  headerName: 'REPPED CUSTOMER',
  minWidth: 250,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
}
export const fieldCounterPartyCol: ColDef = {
  field: 'counter_party',
  headerName: 'COUNTER PARTY NAME',
  minWidth: 200,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldLandingInvoiceIdCol: ColDef = {
  field: 'invoice_id',
  headerName: 'INVOICE NO',
  width: 150,
};

export const fieldDateCol: ColDef = {
  field: 'date',
  headerName: 'DATE CREATED',
  minWidth: 100,
  cellClass: 'ag-flex-align-center',
  cellRenderer: 'date',
};

export const fieldExecutionDateCol: ColDef = {
  field: 'execution_date',
  headerName: 'EXECUTION DATE',
  minWidth: 150,
  cellClass: 'ag-flex-align-center',
  cellRenderer: 'date',
};

export const fieldOccupationDate: ColDef = {
  field: 'occupation_date',
  headerName: 'OCCUPATION DATE',
  minWidth: 150,
  cellClass: 'ag-flex-align-center',
  cellRenderer: 'date',
};

export const fieldSaleCompletionDateCol: ColDef = {
  field: 'sale_completion_date',
  headerName: 'SALE COMPLETION DATE',
  minWidth: 150,
  cellClass: 'ag-flex-align-center',
  cellRenderer: 'date',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};
export const fieldCreditNotesCol: ColDef = {
  field: 'credit_notes',
  headerName: 'ADJUSTMENT NOTES',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};
export const fieldCreditReasonCol: ColDef = {
  field: 'credit_reason',
  headerName: 'ADJUSTMENT REASON',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldPercentageCol: ColDef = {
  field: 'percentage',
  headerName: 'STATUS',
  cellRenderer: 'status',
};

export const fieldBrokerCol: ColDef = {
  field: 'broker',
  headerName: 'ASSIGNED',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
  cellRenderer: 'userIcon',
};

export const fieldNotesCol: ColDef = {
  field: 'peoplesoft_notes',
  headerName: 'NOTES',
  width: 130,
  cellRenderer: 'statusNotes',
};

export const fieldDocumentsCol: ColDef = {
  field: 'documents',
  headerName: 'DOCUMENTS',
  cellRenderer: 'document',
};

export const fieldStatusCol: ColDef = {
  field: 'status_name',
  headerName: 'STATUS',
};

export const fieldTransactionIdCol: ColDef = {
  field: 'transactionid',
  headerName: 'Transaction ID',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldInvoiceIdCol: ColDef = {
  field: 'invoiceid',
  headerName: 'Invoice No',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
  cellRenderer: 'invoiceId',
};

export const fieldCopiedCol: ColDef = {
  field: 'copied',
  headerName: 'Copied',
  width: 20,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldRpnameCol: ColDef = {
  field: 'rpname',
  headerName: 'Name',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldAmountCol: ColDef = {
  field: 'amount',
  headerName: 'Fixed Fee Amount',
  cellRenderer: 'currency',
  minWidth: 200,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldExpenseAmountCol: ColDef = {
  field: 'expense_amount',
  headerName: 'Expense Amount',
  cellRenderer: 'currency',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldExternalBrokerAmountCol: ColDef = {
  field: 'external_broker_amount',
  headerName: 'External Broker Amount',
  cellRenderer: 'currency',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldSubmitterNameCol: ColDef = {
  field: 'submitter_name',
  headerName: 'Submitter Name',
  wrapText: true,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldSubmitDateCol: ColDef = {
  field: 'submitdate',
  headerName: 'Submit Date',
  wrapText: true,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldPplsResponseCol: ColDef = {
  field: 'pplsresponse',
  headerName: 'People Soft Response',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldXmlResponseCol: ColDef = {
  field: 'xmlresponse',
  headerName: 'XML',
  cellRenderer: 'xmlResponse',
  width: 80,
};

export const fieldSubmittedDataCol: ColDef = {
  field: 'submitted_data',
  headerName: 'JSON',
  cellRenderer: 'jsonResponse',
  width: 80,
};

export const fieldTimeStampsCol: ColDef = {
  field: 'time_stamp',
  headerName: 'Time',
  minWidth: 200,
};

export const fieldTransactionTypeCol: ColDef = {
  field: 'transaction_type',
  headerName: 'Transaction Type',
  valueFormatter: (params) => {
    if (`${params?.value}`.toLowerCase() === TransactionTypes.CONSULTATION) params.value = 'Consulting';
    if (`${params?.value}`.toLowerCase() === TransactionTypes.EXPENSE) params.value = 'Disbursement';
    return params.value;
  },
  minWidth: 180,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldSumCol: ColDef = {
  field: 'sum',
  headerName: 'Sum',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldCountCol: ColDef = {
  field: 'count',
  headerName: 'Count',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldCountryCol: ColDef = {
  field: 'country',
  headerName: 'Country',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldTotalTransactionsCol: ColDef = {
  field: 'totalTransactions',
  headerName: 'Total Transactions',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
  valueFormatter: (params) => params.value ? params.value : '0',
};

export const fieldTotalFeeCol: ColDef = {
  field: 'totalFee',
  headerName: 'Total Fee',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
  valueFormatter: (params) => params.value ? params.value : '0',
};

export const fieldTotalUsersCol: ColDef = {
  field: 'totalUsers',
  headerName: 'Total Users',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
  valueFormatter: (params) => params.value ? params.value : '0',
};

export const guiNumber: ColDef = {
  field: 'gui_receipt_number',
  headerName: 'GUI Number',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldActiveUsersCol: ColDef = {
  field: 'activeUsers',
  headerName: 'Active Users',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
  valueFormatter: (params: any) => {
    if (params.value === null || params.value === '0') {
      return 0;
    }
    return params.value;
  },
};

export const fieldMonthCol: ColDef = {
  field: 'month',
  headerName: 'Month',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldYearCol: ColDef = {
  field: 'year',
  headerName: 'Year',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldOppNameCol: ColDef = {
  field: 'opp_name',
  headerName: 'Opp Name',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
  minWidth: 250,
};

export const fieldOppNumberCol: ColDef = {
  field: 'opportunity_number',
  headerName: 'Opp Number',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
  minWidth: 200,
};

export const fieldOpportunityCol: ColDef = {
  field: 'opportunity',
  headerName: 'OPPORTUNITY',
  minWidth: 150,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldOpportunityInstallmentCol: ColDef = {
  field: 'opportunity_installment_id',
  headerName: 'OPPORTUNITY INSTALLMENT ID',
  minWidth: 250,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldOpportunitySourceCol: ColDef = {
  field: 'opportunity_source',
  headerName: 'OPPORTUNITY SOURCE',
  minWidth: 200,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldInvoiceTypeCol : ColDef = {
  field: 'invoice_type',
  headerName: 'INVOICE TYPE',
  minWidth: 100,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldTeamCol : ColDef = {
  field: 'team',
  headerName: 'TEAM',
  minWidth: 180,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldCurrencyCol : ColDef = {
  field: 'currency',
  headerName: 'CURRENCY',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldTransSubtypeCol: ColDef = {
  field: 'transaction_subtype',
  headerName: 'TRANSACTION SUBTYPE',
  minWidth: 200,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldAssetPortfolioTypeCol: ColDef = {
  field: 'asset_type',
  headerName: 'ASSET OR PORTFOLIO TYPE',
  minWidth: 230,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldMiqAvailabilityIdCol: ColDef = {
  field: 'availability_id',
  headerName: 'MIQ AVAILABILITY ID',
  minWidth: 180,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldMiqIdCol: ColDef = {
  field: 'miq_property_id',
  headerName: 'MIQ PROPERTY ID',
  minWidth: 180,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldGridIdCol: ColDef = {
  field: 'grid_id',
  headerName: 'PROPERTY GRID ID',
  minWidth: 180,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldAddressLine1Col: ColDef = {
  field: 'address_line1',
  headerName: 'ADDRESS LINE1',
  minWidth: 170,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldAddressLine2Col: ColDef = {
  field: 'address_line2',
  headerName: 'ADDRESS LINE 2',
  minWidth: 170,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldPostcodeCol: ColDef = {
  field: 'postal_code',
  headerName: 'POSTCODE',
  minWidth: 150,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldSuburbCol: ColDef = {
  field: 'suburb',
  headerName: 'SUBURB',
  minWidth: 120,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldDistrictCol: ColDef = {
  field: 'district',
  headerName: 'DISTRICT',
  minWidth: 120,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldLocalityCol: ColDef = {
  field: 'locality',
  headerName: 'LOCALITY',
  minWidth: 120,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldRegionCol: ColDef = {
  field: 'region',
  headerName: 'REGION',
  minWidth: 110,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldAgileSpaceDetailsCol: ColDef = {
  field: 'agile_space_details',
  headerName: 'AGILE SPACE DETAILS',
  minWidth: 110,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldPropertyTypeCol: ColDef = {
  field: 'property_type',
  headerName: 'PROPERTY TYPE',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldPropertySubtypeCol: ColDef = {
  field: 'property_subtype',
  headerName: 'PROPERTY SUBTYPE',
  minWidth: 190,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldPropertyAreaCol: ColDef = {
  field: 'property_area',
  headerName: 'PROPERTY AREA',
  minWidth: 170,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldSizeAreaMeasureCol: ColDef = {
  field: 'size_area_measure',
  headerName: 'SIZE AREA MEASURE',
  minWidth: 190,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldResidentialUnitsCol: ColDef = {
  field: 'units',
  headerName: 'RESIDENTIAL UNITS',
  minWidth: 190,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldRoomsCol: ColDef = {
  field: 'rooms',
  headerName: 'ROOMS',
  width: 100,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldLandCol: ColDef = {
  field: 'land',
  headerName: 'LAND',
  minWidth: 100,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldLandAreaMeasureCol: ColDef = {
  field: 'land_area_measure',
  headerName: 'LAND AREA MEASURE',
  minWidth: 190,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldCarParkSpacesCol: ColDef = {
  field: 'car_park_spaces',
  headerName: 'CAR PARK SPACES',
  minWidth: 180,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldInvestmentProfileCol: ColDef = {
  field: 'investment_portfolio',
  headerName: 'INVESTMENT PROFILE',
  minWidth: 200,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldTenureCol: ColDef = {
  field: 'tenure',
  headerName: 'TENURE',
  minWidth: 100,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldTenancyCol: ColDef = {
  field: 'tenancy',
  headerName: 'TENANCY',
  minWidth: 110,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldOccupancyPercentageCol: ColDef = {
  field: 'occupancy_percentage',
  headerName: 'OCCUPANCY PERCENTAGE',
  minWidth: 150,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldWaleCol: ColDef = {
  field: 'wale',
  headerName: 'WALE',
  minWidth: 110,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldNetOperatingIncomeCol: ColDef = {
  field: 'net_operating_income',
  headerName: 'NET OPERATING INCOME',
  minWidth: 200,
  cellRenderer: 'currency',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldPurchasePriceCol: ColDef = {
  field: 'purchase_price',
  headerName: 'PURCHASE_PRICE',
  minWidth: 200,
  cellRenderer: 'currency',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldNetYieldCol: ColDef = {
  field: 'net_yield',
  headerName: 'NET YIELD',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldERVCol: ColDef = {
  field: 'gross_revenue_erv',
  headerName: 'ERV(FULLY OCCUPIED)',
  minWidth: 200,
  cellRenderer: 'currency',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldPropertyManagedCol: ColDef = {
  field: 'managed_by_cbre',
  headerName: 'PROPERTY MANAGEMENT BY CBRE',
  minWidth: 270,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldPrimaryEmployeeIdCol: ColDef = {
  field: 'primary_employee_id',
  headerName: 'PRIMARY EMPLOYEE ID',
  minWidth: 200,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldPrimaryEmployeeNameCol: ColDef = {
  field: 'primary_employee_name',
  headerName: 'PRIMARY EMPLOYEE NAME',
  minWidth: 250,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldPrimaryEmployeeFunctionalUnitIdCol: ColDef = {
  field: 'primary_employee_functional_unit_id',
  headerName: 'PRIMARY EMPLOYEE FU ID',
  minWidth: 250,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldPrimaryEmployeeFunctionalUnitCol: ColDef = {
  field: 'primary_employee_functional_unit',
  headerName: 'PRIMARY EMPLOYEE FU DESC',
  minWidth: 250,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldPrimaryEmployeeManagingOfficeIdCol: ColDef = {
  field: 'primary_employee_managing_office_id',
  headerName: 'PRIMARY EMPLOYEE MO ID',
  minWidth: 250,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldPrimaryEmployeeManagingOfficeCol: ColDef = {
  field: 'primary_employee_managing_office',
  headerName: 'PRIMARY EMPLOYEE MO Office DESCRIPTION',
  headerTooltip: 'PRIMARY EMPLOYEE MO Office DESCRIPTION',
  minWidth: 300,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldProducedEmployeeIdCol: ColDef = {
  field: 'producer_employee_id',
  headerName: 'PRODUCED EMPLOYEE ID',
  minWidth: 200,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldProducedNameCol: ColDef = {
  field: 'producer_name',
  headerName: 'PRODUCED NAME',
  minWidth: 250,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldProducedEmployeeFunctionalUnitIdCol: ColDef = {
  field: 'producer_functional_unit',
  headerName: 'PRODUCED EMPLOYEE FU ID',
  minWidth: 250,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldProducedEmployeeFunctionalUnitDescCol: ColDef = {
  field: 'producer_functional_unit_description',
  headerName: 'PRODUCED EMPLOYEE FU DESC',
  minWidth: 250,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldProducedEmployeeManagingOfficeIdCol: ColDef = {
  field: 'producer_managing_office',
  headerName: 'PRODUCED EMPLOYEE MO ID',
  minWidth: 250,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldProducedEmployeeManagingOfficeDescCol: ColDef = {
  field: 'producer_managing_office_description',
  headerName: 'PRODUCED EMPLOYEE MO Office DESCRIPTION',
  headerTooltip: 'PRODUCED EMPLOYEE MO Office DESCRIPTION',
  minWidth: 300,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};
export const fieldProducerRoleCol: ColDef = {
  field: 'producer_role',
  headerName: 'PRODUCER ROLE',
  width: 150,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};
export const fieldBillToCustomerIdCol: ColDef = {
  field: 'bill_to_customer_id',
  headerName: 'BILL TO CUSTOMER ID',
  minWidth: 150,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldDedicatedClientNameBillToCustCol: ColDef = {
  field: 'dedicated_client_name_bill_to_cust',
  headerName: 'DEDICATED CLIENT NAME(BILL TO CUST)',
  minWidth: 200,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldBillToCustomerNameCol: ColDef = {
  field: 'bill_to_customer_name',
  headerName: 'BILL TO CUSTOMER NAME',
  minWidth: 200,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldReppedCustomerIDCol: ColDef = {
  field: 'repped_customer_id',
  headerName: 'REPPED CUSTOMER ID',
  minWidth: 150,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};
export const fieldRepRolCol: ColDef = {
  field: 'representation_role',
  headerName: 'REP ROLE',
  minWidth: 150,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldCustomerIdCol: ColDef = {
  field: 'customer_id',
  headerName: 'CUSTOMER ID',
  minWidth: 150,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldCustomerNameCol: ColDef = {
  field: 'customer_name',
  headerName: 'CUSTOMER NAME',
  minWidth: 200,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldCompanyTypeCol: ColDef = {
  field: 'company_type',
  headerName: 'COMPANY TYPE',
  minWidth: 180,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldDedicatedClientNameCol: ColDef = {
  field: 'dedicated_client_name_repped_cust',
  headerName: 'DEDICATED CLIENT NAME (Repped Customer)',
  minWidth: 180,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldRepCustVehicleCol: ColDef = {
  field: 'repped_customer_vehicle_name',
  headerName: 'REPRESENTED FUNDING VEHICLE',
  minWidth: 200,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldRepCustEquityCol: ColDef = {
  field: 'repped_customer_source_of_equity',
  headerName: 'REPRESENTED EQUITY SOURCE',
  minWidth: 180,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldCounterPartyVehicleCol: ColDef = {
  field: 'counter_party_vehicle_name',
  headerName: 'COUNTER PARTY FUNDING VEHICLE',
  minWidth: 140,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldCounterPartyEquityCol: ColDef = {
  field: 'counter_party_source_of_equity',
  headerName: 'COUNTER PARTY EQUITY SOURCE',
  minWidth: 270,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldPurchaseOrderCol: ColDef = {
  field: 'purchase_order',
  headerName: 'PURCHASE ORDER',
  minWidth: 150,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldMoneyInTrustCol: ColDef = {
  field: 'money_in_trust',
  headerName: 'MONEY IN TRUST',
  minWidth: 150,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldBillingOfficeCol: ColDef = {
  field: 'billing_office',
  headerName: 'BILLING OFFICE',
  minWidth: 150,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldPlaceOfSupplyCol: ColDef = {
  field: 'place_of_supply',
  headerName: 'PLACE OF SUPPLY',
  minWidth: 150,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldSgstUtgstPercentageCol: ColDef = {
  field: 'sgst_utgst_percentage',
  headerName: 'SGST UTGST PERCENTAGE',
  minWidth: 120,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldGstRateCol: ColDef = {
  field: 'gst_rate',
  headerName: 'GST RATE',
  minWidth: 120,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldNewUpdateCol: ColDef = {
  field: 'key',
  headerName: 'New/Update',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldErrorCol: ColDef = {
  field: 'error',
  headerName: 'Error',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldABNCol = {
  field: 'client_abn',
  headerName: 'ABN',
};

export const fieldInvoiceFeeBasisCol: ColDef = {
  field: 'invoice_fee_basis',
  headerName: 'INVOICE FEE BASIS',
  minWidth: 150,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldIsGwsEntityCol: ColDef = {
  field: 'is_gws_entity',
  headerName: 'IS GWS ENTITY',
  minWidth: 180,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldGwsEntityLocationCol: ColDef = {
  field: 'gws_entity_location',
  headerName: 'GWS ENTITY LOCATION',
  minWidth: 200,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldPaymentTermsCol: ColDef = {
  field: 'payment_terms',
  headerName: 'PAYMENT TERMS',
  minWidth: 160,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldOtherIncomeCol: ColDef = {
  field: 'other_income',
  headerName: 'OTHER INCOME',
  minWidth: 150,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldSubFeeTypeCol: ColDef = {
  field: 'sub_fee_type',
  headerName: 'SUB FEE TYPE',
  minWidth: 150,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldInvoiceHeaderCol: ColDef = {
  field: 'invoice_header',
  headerName: 'INVOICE HEADER',
  minWidth: 100,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldTotalInvoiceAmountCol: ColDef = {
  field: 'total_invoice_amount',
  headerName: 'TOTAL INVOICE AMOUNT',
  minWidth: 200,
  cellRenderer: 'currency',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldOperatorCol: ColDef = {
  field: 'operator',
  headerName: 'OPERATOR',
  minWidth: 160,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};
export const fieldBalanceCol: ColDef = {
  field: 'balance',
  headerName: 'BALANCE',
  minWidth: 160,
  cellRenderer: 'currency',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldMasterBillingInvoiceCol: ColDef = {
  field: 'master_billing_invoice',
  headerName: 'MASTER BILLING INVOICE',
  minWidth: 160,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldNoOfPropertiesCol: ColDef = {
  field: 'no_of_properties',
  headerName: 'NO OF PROPERTIES',
  minWidth: 140,
  width: 140,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldCreatedByCol: ColDef = {
  field: 'created_by',
  headerName: 'CREATED BY',
  minWidth: 160,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldSubmittedByCol: ColDef = {
  field: 'submitted_by',
  headerName: 'SUBMITTED BY',
  minWidth: 160,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldApprovedByCol: ColDef = {
  field: 'approved_by',
  headerName: 'APPROVED BY',
  minWidth: 160,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldConfidentialityStatusCol: ColDef = {
  field: 'confidentiality_status',
  headerName: 'CONFIDENTIALITY STATUS',
  minWidth: 220,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldDealTypeAgileSpaceCol: ColDef = {
  field: 'deal_type_agile_space',
  headerName: 'DEAL TYPE AGILE SPACE',
  minWidth: 200,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldOptionToRenewTheLeaseCol: ColDef = {
  field: 'option_to_renew_the_lease',
  headerName: 'OPTION TO RENEW THE LEASE',
  minWidth: 200,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldNoticeOfCancellationInMonthsCol: ColDef = {
  field: 'notice_of_cancellation_in_months',
  headerName: 'NOTICE OF CANCELLATION IN MONTHS',
  minWidth: 250,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldTenantBankGuaranteeAmountCol: ColDef = {
  field: 'tenant_bank_guarentee_amount',
  headerName: 'TENANT BANK GUARANTEE AMOUNT',
  minWidth: 250,
  cellRenderer: 'currency',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldTenantSecurityDepositAmountCol: ColDef = {
  field: 'tenant_security_deposit_amount',
  headerName: 'TENANT SECURITY DEPOSIT AMOUNT',
  minWidth: 250,
  cellRenderer: 'currency',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldContractTypeCol: ColDef = {
  field: 'contract_type',
  headerName: 'CONTRACT TYPE',
  minWidth: 150,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldPropertyTypeSpaceLabelCol: ColDef = {
  field: 'property_type_space_label',
  headerName: 'PROPERTY TYPE SPACE LABEL',
  minWidth: 200,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldSpaceConditionCol: ColDef = {
  field: 'space_condition',
  headerName: 'SPACE CONDITION',
  minWidth: 150,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldFloorCol: ColDef = {
  field: 'floor',
  headerName: 'FLOOR',
  minWidth: 100,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldSuiteCol: ColDef = {
  field: 'suite',
  headerName: 'SUITE',
  minWidth: 100,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldTenantRetailCategoryCol: ColDef = {
  field: 'tenant_retail_category',
  headerName: 'TENANT RETAIL CATEGORY',
  minWidth: 200,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldRetailBrandNameCol: ColDef = {
  field: 'retail_brand_name',
  headerName: 'RETAIL BRAND NAME',
  minWidth: 200,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldDealTypeCol: ColDef = {
  field: 'deal_type',
  headerName: 'DEAL TYPE',
  minWidth: 150,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldAssetValueCol: ColDef = {
  field: 'asset_value',
  headerName: 'ASSET VALUE',
  minWidth: 150,
  cellRenderer: 'currency',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldLoanCapitalCol: ColDef = {
  field: 'loan_capital',
  headerName: 'LOAN CAPITAL',
  minWidth: 150,
  cellRenderer: 'currency',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldPctCol: ColDef = {
  field: 'pct',
  headerName: 'PCT',
  minWidth: 150,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldSupplierTypeCol: ColDef = {
  field: 'supplier_type',
  headerName: 'SUPPLIER TYPE',
  minWidth: 150,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldBooleanCol: ColDef = {
  field: 'gross_fee_include_outgoings',
  headerName: 'GROSS FEE INCLUDE OUTGOINGS',
  minWidth: 250,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldAdditionalFeeTypesCol: ColDef = {
  field: 'additional_fee_types',
  headerName: 'ADDITIONAL FEE TYPES',
  minWidth: 250,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldProjectCodeCol: ColDef = {
  field: 'project_code',
  headerName: 'PROJECT CODE',
  minWidth: 250,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldProjectDescriptionCol: ColDef = {
  field: 'project_description',
  headerName: 'PROJECT DESCRIPTION',
  minWidth: 250,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldGreenSpaceCol: ColDef = {
  field: 'greenspace',
  headerName: 'GREENSAPCE',
  minWidth: 250,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldAccountCodeCol: ColDef = {
  field: 'account_code',
  headerName: 'ACCOUNT CODE',
  minWidth: 150,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldDisbursementIncludedInFeesCol: ColDef = {
  field: 'disbursement_included_in_fees',
  headerName: 'DISBURSEMENT INCLUDED IN FEES',
  minWidth: 250,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldExpenseTypeCol: ColDef = {
  field: 'expense_type',
  headerName: 'EXPENSE TYPE',
  minWidth: 150,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldInfluencerRoleCol: ColDef = {
  field: 'influencer_role',
  headerName: 'INFLUENCER ROLE',
  minWidth: 150,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldExternalBrokerCol: ColDef = {
  field: 'external_broker',
  headerName: 'EXTERNAL BROKER',
  minWidth: 150,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldChecklistQuestionCol: ColDef = {
  field: 'checklist_question',
  headerName: 'CHECKLIST QUESTION',
  minWidth: 400,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldChecklistQuestionNoteCol: ColDef = {
  field: 'checklist_question_note',
  headerName: 'CHECKLIST QUESTION NOTE',
  minWidth: 300,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldTextCol: ColDef = {
  field: '',
  headerName: '',
  minWidth: 250,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldPropertiesCol: ColDef = {
  field: 'property_address',
  headerName: 'PROPERTY',
  cellRenderer: 'property',
  valueParser: (params: any) => ({
    "address_line1": params.value.address_line1,
    "address_line2": params.value.address_line2,
    "address_line3": params.value.address_line3,
    "address_line4": params.value.address_line4,
    "address_line5": params.value.address_line5,
    "address_line6": params.value.address_line6,
    "building_name": params.value.building_name,
    "country": params.value.country,
    "id": params.value.id,
    "locality": params.value.locality,
    "postal_code": params.value.postal_code,
    "region": params.value.region,
  }),
  valueFormatter: (params: any) => {
    if (params.value === null) {
      return '';
    }

    const buildingName = params.value.building_name ? params.value.building_name : '';
    const addressLine1 = params.value.address_line1 ? params.value.address_line1 : '';
    const addressLine2 = params.value.address_line2 ? params.value.address_line2 : '';
    let locality = '', country = '';

    if (params.value.locality && params.value.locality !== '') {
      locality = params.value.locality + ', ';
    }

    if (params.value.country && params.value.country !== '') {
      country = params.value.country;
    }

    return `${buildingName} \n ${addressLine1} ${addressLine2} \n ${locality} ${country}`.trim();
  },
  tooltipValueGetter: (p: ITooltipParams) => p.valueFormatted,
  width: 280,
};

export const deleteInvoiceCol: ColDef = {
  field: 'delete_invoice',
  headerName: '',
  sortable: false,
  width: 100,
  suppressHeaderMenuButton: true,
  suppressMovable: true,
  cellClass: ['ag-flex-align-center', 'ag-flex-justify-center'],
  cellRenderer: 'deleteInvoice',
};

export const updateInvoiceCol: ColDef = {
  field: 'update_invoice',
  headerName: '',
  sortable: false,
  minWidth: 150,
  suppressHeaderMenuButton: true,
  suppressMovable: true,
  cellClass: ['ag-flex-align-center'],
  cellRenderer: 'updateInvoice',
};

export const fieldOpportunityNumberCol: ColDef = {
  field: 'opportunity_number',
  headerName: 'OPPORTUNITY NUMBER',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldOpportunityNameCol: ColDef = {
  field: 'opp_name',
  headerName: 'OPPORTUNITY NAME',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldFunctionalUnitCol: ColDef = {
  field: 'functional_unit',
  headerName: 'FUNCTIONAL UNIT',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldManagingOfficeCol: ColDef = {
  field: 'managing_office',
  headerName: 'MANAGING OFFICE',
  // valueParser: (params: any) => (params.value ? params.value : ''),
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldRepRoleCol: ColDef = {
  field: 'rep_role',
  headerName: 'REP ROLE',
  width: 120,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldParentCompanyNameCol: ColDef = {
  field: 'parent_company_name',
  headerName: 'Parent Company Name',
  width: 200,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldBuildingNameCol: ColDef = {
  field: 'building_name',
  headerName: 'BUILDING NAME',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldSizeCol: ColDef = {
  field: 'size',
  headerName: 'SIZE',
  width: 100,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldSizeUomCol: ColDef = {
  field: 'size_measurement',
  headerName: 'UOM',
  width: 80,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldUnitsCol: ColDef = {
  field: 'units',
  headerName: 'UNITS',
  width: 100,
  tooltipValueGetter: (p: ITooltipParams) => p.value, // TODO: Verify the logic when the invoice_type is ACR (reporting-property-size.component.ts)
};

export const fieldAreaCol: ColDef = {
  field: 'area',
  headerName: 'AREA',
  width: 100,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldAreaUomCol: ColDef = {
  field: 'area_measurement',
  headerName: 'UOM',
  width: 80,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldBrokerIdCol: ColDef = {
  field: 'broker_emplid',
  headerName: 'BROKER ID',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldBrokerNameCol: ColDef = {
  field: 'name',
  headerName: 'BROKER NAME',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldCompanyOfficeCol: ColDef = {
  field: 'company_office',
  headerName: 'COMPANY/OFFICE',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldConjuntionalAgentCol: ColDef = {
  field: 'name',
  headerName: 'CONJUNCTIONAL AGENT',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldOtherPartyCol: ColDef = {
  field: 'other_party',
  headerName: 'OTHER PARTY',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldAffiliateCodeCol: ColDef = {
  field: 'affiliate_code',
  headerName: 'AFFILIATE CODE',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldLobCol: ColDef = {
  field: 'lob',
  headerName: 'LOB',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldValuationFeeCol: ColDef = {
  field: 'valuation_fee',
  headerName: 'VALUATION FEE',
  type: 'currency',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldWeightingPercentageCol: ColDef = {
  field: 'weighting_percentage',
  headerName: 'WEIGHTING PERCENTAGE',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldBuildingNlaCol: ColDef = {
  field: 'building_nla',
  headerName: 'BUILDING NLA',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldMarketValueCol: ColDef = {
  field: 'market_value',
  headerName: 'MARKET VALUE',
  type: 'currency',
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldPropertyBaseIdCol: ColDef = {
  field: 'property_base_id',
  headerName: 'PROPERTY BASE ID',
  minWidth: 180,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldSellerNameCol: ColDef = {
  field: 'seller_name',
  headerName: 'SELLER NAME',
  minWidth: 180,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldIpMetroCol: ColDef = {
  field: 'ip_metro',
  headerName: 'IP METRO',
  minWidth: 120,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};

export const fieldIsDataCenterDealCol: ColDef = {
  field: 'is_data_center_deal',
  headerName: 'IS DATA CENTER DEAL',
  minWidth: 180,
  tooltipValueGetter: (p: ITooltipParams) => p.value,
};
